import moment from "moment";

export const getGregorianDate = (date, delimiter = "-") => {
  const parsed = moment(date);
  if (!parsed.isValid()) return "";

  return parsed.format(`DD${delimiter}MM${delimiter}YYYY`);
};
